import { APIRequest } from './apiRequest';
import { APIImpl } from './api';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { BaseContext } from '../../utils/basecontext';

export class SixdeeCRBTAPI<T extends APIRequest> extends APIImpl<T>
{
    constructor(httpClient:HttpClient, appContext: BaseContext)
    {
        super(httpClient, appContext);
    }

    getBASEURL(): string
    {
        return this.getContext().getProperty().getBaseURLSecuirty() + 
            this.getAPIURL();
    }


   /*  getHttpHeaders(): string{
        return {
            "fingerPrint" : "DD:EB:B6:7C:BD:27:AB:D2:9F:98:45:95:C1:65:49:5F:75:98:9E:31:83:5A:3D:E2:81:4B:E9:E3:F1:8B:B3:EC",
            "appId" : "com.sixdee.callertunes_etisalat",
            "appVersion" : "1.0.6",
            "channelId" : "9",
            "versionCode" : "7",
            "os" : "ios",
            "deviceId" : "0191212",
            "notificationTrackingId" : "",
            "accessToken" : this.getContext().getUserContext().getAccessToken()
        } as any;
    } */
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/sixdeecrbtapi.tsx